export default "__VITE_ASSET__0ae005f8__"